import {
  DEPENDENT_FORM_PROGRESS_TYPES,
  DEPENDENT_FORM_STEPS,
} from './progress.actions';
import { DEPENDENT_FORM_SUBMIT_REDIRECT } from '../../constants';

const initialState = {
  validating: true,
  currentStep: DEPENDENT_FORM_STEPS.ROLE,
  id: null,
  role: null,
  dependent: null,
  registrationCompleted: false,
  careUserCreator: true,
  status: 'new',
  submitRedirect: DEPENDENT_FORM_SUBMIT_REDIRECT.PROFILE,
  metadata: {
    documentationStepEnabled: false,
  },
  registrationSteps: {
    [DEPENDENT_FORM_STEPS.PERSONAL]: false,
    [DEPENDENT_FORM_STEPS.GENERAL]: false,
    [DEPENDENT_FORM_STEPS.DOCUMENTS]: false,
    [DEPENDENT_FORM_STEPS.RELATION]: false,
  },
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case DEPENDENT_FORM_PROGRESS_TYPES.SET_ROLE: {
      return { ...state, role: payload };
    }

    case DEPENDENT_FORM_PROGRESS_TYPES.SET_STEP: {
      return { ...state, currentStep: payload };
    }

    case DEPENDENT_FORM_PROGRESS_TYPES.SET_SUBMIT_REDIRECT: {
      return { ...state, submitRedirect: payload };
    }

    case DEPENDENT_FORM_PROGRESS_TYPES.VALIDATE: {
      return { ...state, validating: true };
    }

    case DEPENDENT_FORM_PROGRESS_TYPES.VALIDATE_FINISH: {
      return { ...state, validating: false };
    }

    case DEPENDENT_FORM_PROGRESS_TYPES.UPDATE_DEPENDENT: {
      const {
        registrationCompleted,
        registrationSteps,
        metadata,
        careUserCreator,
        careRole: role,
        dependent,
        status,
        id,
      } = payload;

      return {
        ...state,
        registrationCompleted,
        registrationSteps,
        metadata,
        careUserCreator,
        dependent,
        status,
        role,
        id,
      };
    }

    case DEPENDENT_FORM_PROGRESS_TYPES.RESET: {
      return initialState;
    }

    default: {
      return state;
    }
  }
};



// WEBPACK FOOTER //
// ./src/redux/dependentForm/progress.js